"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterMappedProducts = void 0;
var _filterData = require("./filterData");
const filterMappedProducts = products => products.filter(_filterData.filterData);
exports.filterMappedProducts = filterMappedProducts;
//# sourceMappingURL=filterMappedProducts.js.map